import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'true');
        setIsVisible(false);
    };

    return (
        <AnimatePresence>
            {isVisible && (
                <motion.div
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 100, opacity: 0 }}
                    className="fixed bottom-0 left-0 right-0 bg-white shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] border-t border-gray-200 p-4 z-50"
                >
                    <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
                        <div className="text-sm text-gray-600 flex-1">
                            <p>
                                Utilizamos cookies propias y de terceros para mejorar nuestros servicios y analizar sus hábitos de navegación.
                                Si continúa navegando, consideramos que acepta su uso. Puede obtener más información en nuestra{' '}
                                <Link to="/cookies" className="text-[#162c35] font-semibold hover:underline">
                                    Política de Cookies
                                </Link>.
                            </p>
                        </div>
                        <div className="flex gap-4">
                            <button
                                onClick={handleAccept}
                                className="bg-[#162c35] text-white px-6 py-2 rounded-full font-medium hover:bg-gray-800 transition-colors text-sm whitespace-nowrap"
                            >
                                Aceptar todas
                            </button>
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default CookieConsent;
